module.exports = __webpack_public_path__ + "static/media/problem_img1.c0b5b0e9.png";